import styles from '../../styles/Loader.module.css';

const NotesPartialSkeleton = ({itemCount = 4}) => {
    return(
        <>
        {Array.from({length: itemCount},(_,index) => (
                    <div key={index} className={styles.skeletonNotesInboxNoteItem}>
                        <div className='d-flex justify-content-between align-items-center'>
                            <div className={styles.skeletonNoteInboxTextUser}></div>
                            <div className={styles.skeletonNoteInboxTextDate}></div>
                        </div>
                        <div className={styles.skeletonNotesInboxNoteTextFull}></div>
                        <div className={styles.skeletonNotesInboxNoteType}></div>
                    </div>
                ))}
        </>
    )
}

export default NotesPartialSkeleton;